import {z} from 'zod';

export const base64ImageSchema = z.string().min(1, 'Image data cannot be empty');

export type Base64Image = z.infer<typeof base64ImageSchema>;
